import { I18n } from "@/i18n/I18n";

export class CustomError extends Error {
  readonly type: string;
  constructor(message: string, type: string) {
    super(message);
    this.name = 'CustomError';
    this.type = type;
  }
}

export class NotFoundError extends CustomError {
  constructor(message: string) {
    super(message, 'NOT_FOUND');
  }
}

export class ValidationError extends CustomError {
  constructor(message: string) {
    super(message, 'VALIDATION');
  }
}

export class ForbiddenError extends CustomError {
  constructor(message?: string) {
    super(message ?? I18n.get('forbidden'), 'FORBIDDEN');
  }
}